import React from 'react';
import '../Administration/Administration.scss';
import { NavLink, Switch, Route } from 'react-router-dom';
import {
  ADMIN_GENERAL_ROUTE,
  USER_ROUTE,
  ADMIN_RESERVATIONS_ROUTE,
  ADMIN_LOTS_ROUTE
} from '../router/routes';
import GeneralSettingsPage from './Administration/GeneralSettingsPage';
import ParkingLotsPage from './Administration/ParkingLotsPage';
import ReservationsPage from './Administration/ReservationsPage';
import ManageUsers from '../Administration/ManageUsers';

function AdministrationPage() {
  return (
    <div className="admin">
      <div className="tab--menu">
        <NavLink exact to={ADMIN_GENERAL_ROUTE}>Obecné</NavLink>
        <NavLink to={ADMIN_RESERVATIONS_ROUTE}>Rezervace</NavLink>
        <NavLink to={USER_ROUTE}>Uživatelé</NavLink>
        <NavLink to={ADMIN_LOTS_ROUTE}>Parkoviště</NavLink>
      </div>
      <div className="tab--content">
        <Switch>
          <Route path={ADMIN_GENERAL_ROUTE} component={GeneralSettingsPage} />
          <Route path={ADMIN_RESERVATIONS_ROUTE} component={ReservationsPage} />
          <Route path={ADMIN_LOTS_ROUTE} component={ParkingLotsPage} />
          <Route path={USER_ROUTE} component={ManageUsers} />
        </Switch>
      </div>
    </div>
  );
}

export default AdministrationPage;
